/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LowStockItemDto } from '../../models/low-stock-item-dto';

export interface StockReportsControllerGetLowStock$Params {
}

export function stockReportsControllerGetLowStock(http: HttpClient, rootUrl: string, params?: StockReportsControllerGetLowStock$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LowStockItemDto>>> {
  const rb = new RequestBuilder(rootUrl, stockReportsControllerGetLowStock.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LowStockItemDto>>;
    })
  );
}

stockReportsControllerGetLowStock.PATH = '/stock/reports/low-stock';
